import type { CSSProperties } from 'react';
import type { TranslatableContent } from 'utils/intl';

export type AlertSeverity = 'info' | 'warning' | 'danger' | 'secondary' | 'success';

export type HighlightedContent = {
  severity: AlertSeverity;
  content: string | TranslatableContent;
  icon?: string;
  isHtml?: boolean;
};

export function isHighlightedContent(val: any): val is HighlightedContent {
  const castedVal = val as HighlightedContent;
  return (!!castedVal.content || castedVal.severity) && !!castedVal.severity;
}

export type Msg = string | TranslatableContent | HighlightedContent;

type DetailsItems = TranslatableContent;

export type UserNotification = Readonly<{
  id: string;
  title: Msg;
  content?: Msg[];
  details?: DetailsItems[];
  level: AlertSeverity;
  closeAutomatically: boolean;
}> &
  Pick<CSSProperties, 'minWidth'>;

export type UserNotificationMap = UserNotification[];
